import React from "react";
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import "bootstrap/dist/css/bootstrap.min.css";
import Fonts from "./css/fonts.css";
import Styles from "./css/styles.css";
import { useSpring, animated } from "react-spring";
import { Controller } from "react-spring/renderprops";
import { Quart, Quint } from "gsap";
import Utils from "./helpers/Utils";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  isTablet,
} from "react-device-detect";
import DOMPurify from "dompurify";
import gsap from "gsap";
import setZIndexMenu from "./components/SetZIndexMenu";
// import { TWEEN } from "three/examples/jsm/libs/tween.module.min.js";
import Cookies from "js-cookie";
import Home from "./components/Home";
import Menu from "./components/Menu";
import { render } from "react-dom";
import { Stage, Container, Sprite, AnimatedSprite } from "@pixi/react";
import { Assets, Texture } from 'pixi.js';
import instagram from "./images/ig.svg";
import linkedin from "./images/in.svg";
import pin from "./images/pin.svg";

const S3 = "https://digitalgardenmx.s3.us-east-1.amazonaws.com";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      containerLoaderDisplay: "block",
      animatedSprite0: [],
      animatedSprite1: [],
      clip0Visible: true,
      clip1Visible: false,
      canvasW: window.innerWidth,
      canvasH: window.innerHeight,
      animPositionX: window.innerWidth / 2,
      animPositionY: window.innerHeight / 2,
      showCookies: "none"
    };
    this.containerLoader = React.createRef();
    this.animation0 = React.createRef();
    this.animation1 = React.createRef();
    this.home = React.createRef();
    this.cursor = React.createRef();
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
    this.addListeners();
    this.getFirstTexture();
  }

  getTexture = async (url) => {
    let response = await Assets.load(url);
    Assets.reset();
    return response;
  };

  addListeners = () => {
    window.addEventListener("mousemove", this.onMouseMove);
    window.addEventListener("resize", this.onResize);
  }

  onMouseMove = (event) => {
    const el = this.cursor.current;
    el.style.left = event.clientX + "px";
    el.style.top = event.clientY + "px";

    const clickable = event.target.closest('a, button, input, [role="button"], .work-item');
    el.classList.toggle('cursor-hover', !!clickable);
  };

  onResize = (event) => {
    this.setState({
      canvasW: window.innerWidth,
      canvasH: window.innerHeight,
      animPositionX: window.innerWidth / 2,
      animPositionY: window.innerHeight / 2
    });
  };

  getFirstTexture = () => {
    this.getTexture(`${S3}/common/texture-0.json`)
    .then((response) => {
      var frames = [];
      for (let k in response.textures) {
        frames.push(response.textures[k]);
      }
      this.setState({
        animatedSprite0: frames
      });
      this.getSecondTexture();
    })
    .catch((err) => {
      console.log(err);
    });
  }

  getSecondTexture = () => {
    this.getTexture(`${S3}/common/texture-1.json`)
      .then((response) => {
        var frames = [];
        for (let k in response.textures) {
          frames.push(response.textures[k]);
        }
        this.setState({
          animatedSprite1: frames
        });
        setTimeout(() => {
          this.animation0.current.gotoAndPlay(0);
        }, 100);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  animComplete = () => {
    if (this.state.clip0Visible == true) {
      this.setState({
        clip0Visible: false,
        clip1Visible: true
      });
      setTimeout(() => {
        this.animation1.current.gotoAndPlay(0);
      }, 100);
    }
  }

  animComplete1 = () => {
    gsap.to(this.animation1.current, {
      duration: 0.7,
      alpha: 0,
      ease: "linear",
      delay: 0,
      onComplete: () => {
        this.finishSplash();
        this.setState({
          clip0Visible: false,
          clip1Visible: false
        });
        this.animation0.current.gotoAndStop(0);
        this.animation1.current.gotoAndStop(0);
        this.animation1.current.alpha = 1;
      },
      onUpdate: () => {},
    });
  }

  showLoader = (
    duration,
    delay,
    showSplash = false,
    completion
  ) => {
    this.setState({
      containerLoaderDisplay: "block"
    });
    gsap.to(this.containerLoader.current, {
      duration: duration,
      opacity: 1,
      ease: "linear",
      delay: delay,
      onComplete: () => {
        if (completion) {
          completion();
          if (showSplash == true) {
            this.setState({
              clip0Visible: true,
              clip1Visible: false,
            });
            this.animation0.current.gotoAndPlay(0);
          }
        }
      },
      onUpdate: function () {},
    });
  };

  hideLoader = (duration, delay) => {
    gsap.to(this.containerLoader.current, {
      duration: duration,
      opacity: 0,
      ease: "linear",
      delay: delay,
      onComplete: () => {
        this.setState({
          containerLoaderDisplay: "none",
        });
      },
    });
  };

  render() {
    let splashCanvas;
    let w = window.innerWidth;
    let h = window.innerHeight;
    if (this.state.animatedSprite0.length === 0 || this.state.animatedSprite1.length === 0) {
      splashCanvas = <span></span>;
    } else {
      w = (w > 720) ? 720 : w;
      h = (w > 720) ? 415 : ((w) * 415) / 720;
      splashCanvas =  <Stage className="splash-canvas" width={this.state.canvasW} height={this.state.canvasH} options={{ backgroundAlpha: 0 }}>
                        <AnimatedSprite 
                          x={this.state.animPositionX}
                          y={this.state.animPositionY}
                          width={w}
                          height={h}
                          ref={this.animation0}
                          anchor={0.5}
                          textures={this.state.animatedSprite0}
                          isPlaying={false}
                          initialFrame={0}
                          animationSpeed={0.4}
                          loop={false}
                          onComplete={this.animComplete}
                          visible={this.state.clip0Visible} />
                        <AnimatedSprite 
                          x={this.state.animPositionX}
                          y={this.state.animPositionY}
                          width={w}
                          height={h}
                          ref={this.animation1}
                          anchor={0.5}
                          textures={this.state.animatedSprite1}
                          isPlaying={false}
                          initialFrame={0}
                          animationSpeed={0.4}
                          loop={false}
                          onComplete={this.animComplete1}
                          visible={this.state.clip1Visible} />
                      </Stage>;
    }

    return (
      <Router basename={process.env.PUBLIC_URL}>
        <div className="App">
          <Routes>
            <Route
              exact
              path="/"
              element={
                <Home
                  show-loader={this.showLoader}
                  hide-loader={this.hideLoader}
                  finishSplash={finishSplash => this.finishSplash = finishSplash}
                ></Home>
              }
            ></Route>            
          </Routes>
          <div
            ref={this.containerLoader}
            style={{ display: this.state.containerLoaderDisplay }}
            className="container-splash"
          >
            <div className="container-splash-canvas">
              {splashCanvas}
            </div>
          </div>
          <div className="cursor" ref={this.cursor}>
            <div className="cursor-cross"></div>
          </div>
        </div>
      </Router>
    );
  }
}

// Silencia el warning benigno de ResizeObserver (generado por Splide)
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// Desregistrar cualquier service worker previo
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(r => r.unregister());
  });
}
